// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import login from "@/views/login";
// 首页
import index from "@/views/index";
// 编辑信息
import edit from "@/views/charts/edit";
// 修改密码
import editPwd from "@/views/charts/editPwd";
/**
 * 基础菜单
 */
// 商品管理
import Goods from "@/views/goods/Goods";
//陀螺仪数据
import Gyroscope from "@/views/goods/gyroscope";
// 机器信息管理
import Machine from "@/views/machine/Machine";
// 货道信息管理
import MachineAisle from "@/views/machine/MachineAisle";
/**
 * 订单管理
 */
// 交易订单
import Order from "@/views/pay/Order";
/**
 * 系统管理
 */
// 专职人员管理
import user from "@/views/system/user";
// 菜单管理
import Module from "@/views/system/Module";
// 角色管理
import Role from "@/views/system/Role";
// 公司管理
import Dept from "@/views/system/Dept";
// 系统环境变量
import Variable from "@/views/system/Variable";
// 权限管理
import Permission from "@/views/system/Permission";
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from "@/views/machine/MachineConfig";
// 支付配置
import Config from "@/views/pay/Config";
/**
 * 数据监控
 */
// 监控查询
import druidLogin from "@/views/druid/login";

// 感染评审
import statistics from "@/views/charts/statistics";
// 12项指标
import indicators from "@/views/charts/indicators";
// 现患率数据上报
import prevalence from "@/views/charts/prevalence";
// 手卫生数据上报
import handhygiene from "@/views/charts/handhygiene";

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
  routes: [
    {
      path: "/",
      name: "",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: "/login",
      name: "登录",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: "/index",
      name: "首页",
      component: index,
      iconCls: "el-icon-tickets",
      children: [
        {
          path: "/goods/Goods",
          name: "商品管理",
          component: Goods,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/goods/gyroscope",
          name: "陀螺仪数据",
          component: Gyroscope,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/machine/Machine",
          name: "机器信息管理",
          component: Machine,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/machine/MachineAisle",
          name: "货道信息管理",
          component: MachineAisle,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/pay/Order",
          name: "交易订单",
          component: Order,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/system/user",
          name: "专职人员管理",
          component: user,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/system/Module",
          name: "菜单管理",
          component: Module,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/system/Role",
          name: "角色管理",
          component: Role,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/system/Dept",
          name: "公司管理",
          component: Dept,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/system/Variable",
          name: "系统环境变量",
          component: Variable,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/system/Permission",
          name: "权限管理",
          component: Permission,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/machine/MachineConfig",
          name: "支付配置信息",
          component: MachineConfig,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/pay/Config",
          name: "支付配置",
          component: Config,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/druid/login",
          name: "监控查询",
          component: druidLogin,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/charts/statistics",
          name: "感染评审",
          component: statistics,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/charts/indicators",
          name: "12项指标",
          component: indicators,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/charts/prevalence",
          name: "现患率数据上报",
          component: prevalence,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/charts/handhygiene",
          name: "手卫生数据上报",
          component: handhygiene,
          meta: {
            requireAuth: true,
          },
        },
        {
          path: "/edit",
          name: "编辑医院信息",
          component: edit,
          meta: {
            requireAuth: false,
          },
        },
        {
          path: "/editPwd",
          name: "修改密码",
          component: editPwd,
          meta: {
            requireAuth: false,
          },
        },
      ],
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js